import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Theme } from 'src/app/shared/Models/Models';
import { IviMy26Service } from '../ivi-my26.service';


@Component({
  selector: 'app-ivi-subscription-package-details',
  templateUrl: './ivi-subscription-package-details.component.html',
  styleUrls: ['./ivi-subscription-package-details.component.scss'],
  standalone: false
})
export class IviSubscriptionPackageDetailsComponent implements OnInit {
  errorCode: string = "000";
  errorFlag: boolean = false;
  planDetails: any;
  theme: Theme = 'light-theme';
  promoMessage: string = '';
  packagePrice: number = 0;
  infoContent: string = '';
  appName: string = '';
  planInfo: any;
  pageName: string = "Package";
  constructor(private router: Router, public iviService: IviMy26Service, @Inject(DOCUMENT) private document: Document) { }

  ngOnInit(): void {
    this.errorFlag = false;
    this.planDetails = this.iviService.getSelectedPkgDetails();
    this.planInfo = this.planDetails.featureList.featureInfo
    this.switchTheme();
    this.iviService.setTranslatedTitle(this.planDetails.packageDisplayName);
    this.setPromoDetails();
    this.appName = this.iviService.getMyVehicleInfoMY26().DivisionName;
    this.validateToken();
    this.iviService.triggerIVIAmplitudeEventWithProperties({ isAcura: this.iviService.getIsAcura(), eventName: 'View: Package', properties: { 'Page': this.pageName, 'Status': this.planDetails.planDisplayName } });
  }

  trackByFeature(index: number, feature: { heading?: string; logo?: string; description?: string }): string | number {
    return feature?.heading || feature?.logo || feature?.description || index;
  }

  switchTheme() {
    this.document.body.classList.replace(
      this.theme, 'dark-theme'
    );
  }

  goToQRCode() {
    this.iviService.triggerIVIAmplitudeEventWithProperties({ isAcura: this.iviService.getIsAcura(), eventName: 'Action: Open', properties: { 'Page': this.pageName}});
    this.router.navigate(['/shared/qr-code']);
  }

  validateToken() {
    this.iviService.validateIviToken().subscribe((res) => {
      if (res && res.message === 'OK') { }
    },
      (err) => {
        this.errorCode = err.status ?? 500;
        this.errorFlag = true;
      }
    )
  }

  setPromoDetails() {
    if (this.planDetails.isTrialActive || !this.planDetails.isSubscriptionActive) {
      this.promoMessage = "SUBSCRIBE_AT";
      this.packagePrice = this.planDetails.monthlyPrice;
    }

    if (this.planDetails.isTrialEligible && !this.planDetails.isTrialActive) {
      this.promoMessage = "TRY_FOR";
      this.packagePrice = this.planDetails.trialPrice;
    }

    if (this.planDetails.isSubscriptionActive) {
      this.promoMessage = "MANAGE";
    }
  }
}